export default "__VITE_ASSET__B_3sy2NI__"